import styled from 'styled-components/macro';
import { FlexColumn, FlexJustifyBetween } from '../../../../../shared-styles/flex';

export const Header = styled.div`
  font-size: ${({ theme }) => theme.typography.sizes.small};
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  color: ${({ theme }) => theme.palette.black[50]};
`;

export const TrackingStatus = styled.span`
  font-size: ${({ theme }) => theme.typography.sizes.medium};
  font-weight: ${({ theme }) => theme.typography.weight.semiBold};
  color: ${({ theme }) => theme.palette.black[100]};
  margin-right: ${(props) => props.theme.spacing(5)};
`;

export const ELDStatus = styled.div`
  font-size: ${({ theme }) => theme.typography.sizes.small};
  font-weight: ${({ theme }) => theme.typography.weight.semiBold};
`;

export const TransitTrackerPeekView = styled.div`
  ${FlexJustifyBetween}
  padding: ${(props) => props.theme.spacing(15)} ${(props) => props.theme.spacing(20)};
  background-color: ${({ hasErr, theme }) => (hasErr ? theme.palette.custom.lightRed : theme.palette.white)};
`;

export const CardContent = styled.div`
  ${FlexColumn}
  flex: 1;
`;

export const Logo = styled.div`
  width: 150px;
  flex: 1;
`;

export const TruckerToolsLogo = styled.img`
  width: 156px;
  margin: ${({ theme }) => theme.spacing(10)} 0;
`;

export const FourKitesLogo = styled.img`
  width: 143px;
`;

export const CardRightSide = styled.div`
  ${FlexColumn}
  align-items: center;
`;
